import { render } from "./area.vue?vue&type=template&id=ca50a2ca"
import script from "./area.vue?vue&type=script&lang=js"
export * from "./area.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/submission_form/area.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca50a2ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca50a2ca', __exports__)) {
    api.reload('ca50a2ca', __exports__)
  }
  
  module.hot.accept("./area.vue?vue&type=template&id=ca50a2ca", () => {
    api.rerender('ca50a2ca', render)
  })

}


export default __exports__